/**
 * Converte item one-off do carrinho para assinatura e grava a property da promo.
 */
(function () {
  if (window.cartSubscriptionPromoInit) return;
  window.cartSubscriptionPromoInit = true;

  const ROOT_LOADING_CLASS = 'cart-subscription-promo--loading';
  const PROPERTY_KEY = 'Promoção';

  function setButtonLoading(button, isLoading) {
    if (!button) return;

    button.disabled = isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    const root = button.closest('[data-cart-subscription-promo]');
    root?.classList.toggle(ROOT_LOADING_CLASS, isLoading);

    const label = button.querySelector('.cart-subscription-promo__button-label');
    const loading = button.querySelector('.cart-subscription-promo__button-loading');

    label?.classList.toggle('hidden', isLoading);
    loading?.classList.toggle('hidden', !isLoading);
    if (loading) loading.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function collectExistingProperties(itemRoot) {
    const properties = {};
    if (!itemRoot) return properties;

    itemRoot.querySelectorAll('.product-option dt').forEach((dt) => {
      const key = dt.textContent.replace(/:$/, '').trim();
      const value = dt.nextElementSibling?.textContent?.trim();
      if (key && value && key !== PROPERTY_KEY) properties[key] = value;
    });

    return properties;
  }

  async function refreshCartViews() {
    const drawerItems = document.querySelector('cart-drawer-items');
    const pageItems = document.querySelector('cart-items');
    const tasks = [];

    if (drawerItems?.onCartUpdate) tasks.push(drawerItems.onCartUpdate());
    if (pageItems?.onCartUpdate) tasks.push(pageItems.onCartUpdate());

    if (tasks.length) {
      await Promise.all(tasks);
    }

    const footer = document.getElementById('main-cart-footer');
    if (footer?.dataset.id) {
      const footerResponse = await fetch(`${routes.cart_url}?section_id=${footer.dataset.id}`);
      const footerHtml = await footerResponse.text();
      const footerDoc = new DOMParser().parseFromString(footerHtml, 'text/html');
      const sourceFooter = footerDoc.querySelector('.js-contents');
      const targetFooter = footer.querySelector('.js-contents');
      if (sourceFooter && targetFooter) targetFooter.innerHTML = sourceFooter.innerHTML;
    }

    if (tasks.length) return;

    const cartDrawer = getCartDrawer();
    if (!cartDrawer) return;

    const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const sourceInner = doc.querySelector('.drawer__inner');
    const targetInner = document.querySelector('cart-drawer .drawer__inner');

    if (sourceInner && targetInner) {
      targetInner.innerHTML = sourceInner.innerHTML;
    }
  }

  async function convertToSubscription(button) {
    const variantId = button.dataset.variantId;
    const sellingPlanId = button.dataset.sellingPlanId;
    const lineKey = button.dataset.lineKey;
    const quantity = parseInt(button.dataset.quantity || '1', 10);
    const promoProperty = button.dataset.promoProperty;
    const itemRoot = button.closest('.cart-item');

    if (!variantId || !sellingPlanId || !lineKey) return;

    setButtonLoading(button, true);

    try {
      const properties = collectExistingProperties(itemRoot);
      if (promoProperty) properties[PROPERTY_KEY] = promoProperty;

      const addData = new FormData();
      addData.append('id', variantId);
      addData.append('quantity', String(quantity));
      addData.append('selling_plan', sellingPlanId);
      Object.keys(properties).forEach((key) => {
        addData.append(`properties[${key}]`, properties[key]);
      });

      const addConfig = fetchConfig('javascript');
      addConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete addConfig.headers['Content-Type'];
      addConfig.body = addData;

      const addResponse = await fetch(`${routes.cart_add_url}`, addConfig);
      const addJson = await addResponse.json();

      if (addJson.status) {
        throw new Error(addJson.description || addJson.message);
      }

      const changeResponse = await fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
        }),
      });
      const changeJson = await changeResponse.json();

      if (changeJson.errors || changeJson.status) {
        throw new Error(changeJson.description || changeJson.message || changeJson.errors);
      }

      await refreshCartViews();
    } catch (error) {
      console.error('Erro ao converter para assinatura:', error);
      await refreshCartViews();
    } finally {
      if (button.isConnected) setButtonLoading(button, false);
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-subscription-action]');
    if (!button) return;

    event.preventDefault();
    convertToSubscription(button);
  });
})();
